<template>
  <button
    class="py-3 px-5 relative overflow-hidden btn bg-secondary  w-auto text-darkblue font-semibold hover:bg-darkblue hover:text-white duration-300"
    @click="handlePopup">
    Request Service
  </button>
</template>
<script setup>
const emit = defineEmits(["closePopup"]);
const handlePopup = () => {
  emit("closePopup");
};

</script>

<style scoped>

button.btn::after {
  content: '';
  position: absolute;
  width: 100px;
  height: 100%;
  top: 0;
  left: -100px;
  background-image: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.7), transparent);
  animation: shine 4s linear infinite;

}

button.btn:hover {
  opacity: 0.8;
  transition-duration: 0.3s;
}

@keyframes shine {
  0% {
    left: -100px;
  }

  20% {
    left: 100%;
  }

  100% {
    left: 100%;
  }
}</style>